/**
 * TanStack Query hook for loading document templates.
 */

import { useQuery } from "@tanstack/react-query";
import { dataProviders } from "../services/data";

export function useDocumentTemplatesQuery(enabled: boolean) {
	return useQuery({
		queryKey: ["documentTemplates"],
		queryFn: () => dataProviders.documentTemplate.getAll(),
		enabled,
		staleTime: 60_000, // 1 min - reduce refetches to avoid 429
		refetchOnMount: true,
		refetchOnWindowFocus: false, // avoid 429 when switching tabs
	});
}
